import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { isDirty, isInvalid, isSubmitting } from "redux-form"
import { Box } from "@infotech/uikit-grid"
import CrudModal from "src/components/CrudModal"
import {
  FORM_NAME,
  selectStatus,
  selectAllPermissions,
  submitForm,
  initForm,
} from "src/engine/modules/rolesForm"
import RolesForm from "./RolesForm"

const enhancer = connect(
  state => ({
    isPending: selectStatus(state).pending,
    isInvalid: isInvalid(FORM_NAME)(state),
    isDirty: isDirty(FORM_NAME)(state),
    isSubmitting: isSubmitting(FORM_NAME)(state),
    allPermissions: selectAllPermissions(state),
  }),
  {
    submitForm,
    initForm,
  },
)

const RolesModal = props => {
  const {
    role,
    roleName,
    onCancel,
    submitForm,
    initForm,
    isDirty,
    isInvalid,
    isPending,
    allPermissions,
    isSubmitting,
  } = props

  useEffect(() => {
    initForm(role)
  }, [role])

  return (
    <CrudModal
      title="Редактирование полномочий"
      dirty={isDirty}
      invalid={isInvalid}
      pending={isPending || isSubmitting}
      submitHandler={submitForm}
      resetHandler={() => {
        onCancel()
      }}
      isOpen
      width={439}
      fullHeight
    >
      <Box h="100%">
        <RolesForm
          permissions={allPermissions}
          roleName={roleName}
          onCancel={onCancel}
          onSubmit={submitForm}
        />
      </Box>
    </CrudModal>
  )
}

RolesModal.propTypes = {
  role: PropTypes.string.isRequired,
  roleName: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  initForm: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  // Выключено, потому что не используется в самом компоненте, только прокидывается
  // eslint-disable-next-line react/forbid-prop-types
  allPermissions: PropTypes.array.isRequired,
}

export default enhancer(RolesModal)
